import FeatureFlags from '../../../../util/featureFlags';

// WEBSITE NAV - POST AUTH
const manageWebsite = {
  navUrl: '/wedding/manage/website/manage',
  navText: 'Manage Website',
};

const editWebsite = {
  navUrl: '/wedding/manage/website/pages/home',
  navText: 'Edit Pages',
};

const viewDesigns = {
  navUrl: '/wedding/manage/website/designs',
  navText: 'View Designs',
};

// GUEST LIST NAV - POST AUTH
const guestDirectory = {
  navUrl: '/wedding/manage/guests/all',
  navText: 'All Guests',
};

const buildGuestLists = {
  navUrl: '/wedding/manage/guests/build',
  navText: 'Build Guest Lists',
};

const addressEnvelopes = {
  navUrl: '/wedding/manage/guests/envelopes',
  navText: 'Address Envelopes',
};

const trackRSVP = {
  navUrl: '/wedding/manage/guests/rsvps/overview',
  navText: 'Track RSVPs',
};

const requestRsvpAccess = {
  navUrl: '/wedding/manage/guests/rsvp-notifications',
  receivesNotifications: true,
  navText: 'View RSVP Requests'
};


// PREAUTH NAV - PRE AUTH
const preauthPlanning = {
  navUrl: '/wedding-planning',
  navText: 'Home',
};

const preauthWebsite = {
  navUrl: '/wedding-planning/website',
  navText: 'Website',
};

const preauthChecklist = {
  navUrl: '/wedding-planning/checklist',
  navText: 'Wedding Checklist',
};

const preauthGuestList = {
  navUrl: '/wedding-planning/guests',
  navText: 'Guest List',
};

const planningDashboard = {
  navUrl: '/wedding/manage',
  navText: 'Planning Dashboard'
};

const website = {
  navUrl: '/wedding/manage/website',
  navText: 'Website'
};

const guestList = {
  navUrl: '/wedding/manage/guests',
  navText: 'Guest List',
  receivesNotifications: true
};

const events = {
  navUrl: '/wedding/manage/events',
  navText: 'Events'
};

const checklist = {
  navUrl: '/wedding/manage/checklist',
  navText: 'Wedding Checklist'
};

// INSPIRATION

const realWeddings = {
  navUrl: '/inspiration/weddings',
  navText: 'Real Weddings',
  notReactLink: true,
};

const austin = {
  navUrl: '/inspiration/weddings?location=Austin%2C+TX',
  navText: 'Austin, TX',
  notReactLink: true,
};

const charlottesville = {
  navUrl: '/inspiration/weddings?location=Charlottesville%2C+VA',
  navText: 'Charlottesville, VA',
  notReactLink: true,
};

const charleston = {
  navUrl: '/inspiration/weddings?location=Charleston%2C+SC',
  navText: 'Charleston, SC',
  notReactLink: true,
};

const chicago = {
  navUrl: '/inspiration/weddings?location=Chicago%2C+IL',
  navText: 'Chicago, IL',
  notReactLink: true,
};

const denver = {
  navUrl: '/inspiration/weddings?location=Denver%2C+CO',
  navText: 'Denver, CO',
  notReactLink: true,
};

const miami = {
  navUrl: '/inspiration/weddings?location=Miami%2C+FL',
  navText: 'Miami, FL',
  notReactLink: true,
};

const napa = {
  navUrl: '/inspiration/weddings?location=Napa%2C+CA',
  navText: 'Napa, CA',
  notReactLink: true,
};

const nashville = {
  navUrl: '/inspiration/weddings?location=Nashville%2C+TN',
  navText: 'Nashville, TN',
  notReactLink: true,
};

const newOrleans = {
  navUrl: '/inspiration/weddings?location=New+Orleans%2C+LA',
  navText: 'New Orleans, LA',
  notReactLink: true,
};

const newYork = {
  navUrl: '/inspiration/weddings?location=New+York%2C+NY',
  navText: 'New York, NY',
  notReactLink: true,
};

const richmond = {
  navUrl: '/inspiration/weddings?location=Richmond%2C+VA',
  navText: 'Richmond, VA',
  notReactLink: true,
};

const sanFrancisco = {
  navUrl: '/inspiration/weddings?location=San+Francisco%2C+CA',
  navText: 'San Francisco, CA',
  notReactLink: true,
};

const seattle = {
  navUrl: '/inspiration/weddings?location=Seattle%2C+WA',
  navText: 'Seattle, WA',
  notReactLink: true,
};

const tampa = {
  navUrl: '/inspiration/weddings?location=Tampa%2C+FL',
  navText: 'Tampa, FL',
  notReactLink: true,
};

const viewAllWeddings = {
  navUrl: '/inspiration/weddings',
  navText: 'View All Weddings',
  notReactLink: true
};

const weddingVendors = {
  navUrl: '/inspiration/wedding-venues',
  navText: 'Wedding Vendors',
  notReactLink: true,
};

const weddingVenues = {
  navUrl: '/inspiration/wedding-venues',
  navText: 'Wedding Venues',
  notReactLink: true,
};

const photographers = {
  navUrl: '/inspiration/wedding-photographers',
  navText: 'Photographers',
  notReactLink: true,
};

const planners = {
  navUrl: '/inspiration/wedding-planners-designers',
  navText: 'Wedding Planners',
  notReactLink: true,
};

const florists = {
  navUrl: '/inspiration/wedding-florists',
  navText: 'Florists',
  notReactLink: true,
};

const caterers = {
  navUrl: '/inspiration/wedding-catering',
  navText: 'Catering',
  notReactLink: true,
};

const makeup = {
  navUrl: '/inspiration/wedding-hair-makeup',
  navText: 'Hair and Makeup',
  notReactLink: true,
};

const viewMoreVendors = {
  navUrl: '/inspiration/wedding-vendors',
  navText: 'View More',
  notReactLink: true,
};

const becomeAVendor = {
  navUrl: '/inspiration/manage/listings',
  navText: 'Become a Vendor',
  notReactLink: true,
  showFn: userContext => !userContext.is_inspiration_vendor
};

// INVITES + PAPER
const invitesPaperLP = {
  navUrl: '/wedding-planning/paper',
  navText: 'Invites + Paper',
  showFn: userContext => !userContext.has_invitation_account
};

const invitesPaperAccountLP = {
  navUrl: '/wedding-planning/save-the-date/shop',
  navText: 'Invites + Paper',
  showFn: userContext => userContext.has_invitation_account
};

const saveTheDate = {
  navUrl: '/wedding-planning/save-the-date/shop',
  navText: 'Save The Dates'
};

const invitations = {
  navUrl: '/wedding-planning/invitations/shop',
  navText: 'Invitations'
};

const enclosureCards = {
  navUrl: '/wedding-planning/enclosures/shop',
  navText: 'Enclosure Cards'
};

const menus = {
  navUrl: '/wedding-planning/menus/shop',
  navText: 'Menus'
};

const programs = {
  navUrl: '/wedding-planning/programs/shop',
  navText: 'Programs'
};

const thankYouCards = {
  navUrl: '/wedding-planning/thank-you-cards/shop',
  navText: 'Thank You Cards'
};

const draperJames = {
  navUrl: '/wedding-planning/draper-james/shop',
  navText: 'Draper James',
  showFn: () => FeatureFlags.get('invitesPLPDraperJames')
};

const ordersDrafts = {
  navUrl: '/wedding-planning/projects',
  navText: 'Your Orders + Drafts',
  showFn: userContext => userContext.has_invitation_account
};

// EXPERT ADVICE
const expertAdvice = {
  navUrl: '/expert-advice',
  navText: 'Expert Advice',
  notReactLink: true
};

export const weddingWebsiteNavItems = [manageWebsite, editWebsite, viewDesigns];
export const guestListNavItems = [guestDirectory, buildGuestLists, addressEnvelopes, trackRSVP, requestRsvpAccess];
export const inspirationWeddingNavItems = [austin, charlottesville, charleston, chicago, denver, miami, napa, nashville, newOrleans, newYork, richmond, sanFrancisco, seattle, tampa, viewAllWeddings];
export const inspirationVendorNavItems = [weddingVenues, photographers, planners, florists, caterers, makeup, viewMoreVendors, becomeAVendor];
export const invitesPaperNavItems = [saveTheDate, invitations, enclosureCards, menus, programs, thankYouCards, draperJames, ordersDrafts];
export const invitesPaperNavItemsMobile = [saveTheDate, invitations, enclosureCards, menus, programs, thankYouCards, draperJames];

export const newPreAuthNavItems = [
  preauthChecklist,
  preauthGuestList,
  [realWeddings, inspirationWeddingNavItems],
  [weddingVendors, inspirationVendorNavItems],
  expertAdvice
];

export const preauthNavItems = window.zola.feature.newUnifiedNav ? newPreAuthNavItems : [
  preauthPlanning,
  preauthWebsite,
  preauthChecklist,
  preauthGuestList,
  [realWeddings, inspirationWeddingNavItems],
  [weddingVendors, inspirationVendorNavItems],
  [invitesPaperLP, invitesPaperNavItems],
  [invitesPaperAccountLP, invitesPaperNavItems],
  expertAdvice
];

export const newManageNavItems = [
  planningDashboard,
  [guestList, guestListNavItems],
  events,
  checklist,
  [realWeddings, inspirationWeddingNavItems],
  [weddingVendors, inspirationVendorNavItems],
  expertAdvice
];

export const manageNavItems = window.zola.feature.newUnifiedNav ? newManageNavItems : [
  planningDashboard,
  [website, weddingWebsiteNavItems],
  [guestList, guestListNavItems],
  events,
  checklist,
  [realWeddings, inspirationWeddingNavItems],
  [weddingVendors, inspirationVendorNavItems],
  [invitesPaperLP, invitesPaperNavItems],
  [invitesPaperAccountLP, invitesPaperNavItems],
  expertAdvice
];



// WEBPACK FOOTER //
// ./src/components/common/header/SecondaryNav/secondaryNavData.js